import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import img_qr from '../../../files/system/QR_Max.png';
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../util/ErrorAdd";

function BlockProviderMaxAdd({ show, onHide }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState(null);
    const [link, setLink] = useState("https://max.ru/id601201555804_bot?start");

    const id_object = 1 //МАКС

    //ОТКРЫТИЕ/ЗАКРЫТИЕ МОДАЛЬНОЕ ОКНО
    useEffect(() => {
        //открытие
        if (show === true) {
            setLog(null);
            setLoading(true);

            axios.get('/api_tracker/bot/integrationCode', { params: { ID_Object: id_object } })
                .then((res) => {
                    if (res.data.Status !== 1) {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                    else {
                        setCode(res.data.Data);
                        setLink("https://max.ru/id601201555804_bot?start=integration." + res.data.Data)
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }, [show]);

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Интеграция Max Bot</div>

                    {log === null ?
                        <div className="mb-20 fs-5">
                            <div className="row">
                                <div className="col-md-4">
                                    <a href={link} target="_blank">
                                        <img className="" src={img_qr} style={{ width: "100%" }}></img>
                                    </a>
                                </div>
                                <div className="col-md-8">
                                    <div>1. Для автоматическрой интеграции откройте Макс Bot по ссылке <a href={link} target="_blank">@601201555804_bot</a>
                                        <br></br> или отсканируйте QR код</div>
                                    <div>2. Нажмите Start</div>
                                    <div>3. Введите код интеграции: </div>
                                    <div className="text-center" style={{ fontSize: '28px' }}><b>{code}</b></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}><i>Код активен 15 минут</i></div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="form_error" style={{ height: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{log}</div>
                    }
                    {loading === true && <div className="loader_01"></div>}
                </Modal.Body>
            </Modal>
        </>
    );
}
export default BlockProviderMaxAdd;
